import { Box, CircularProgress } from "@mui/material";

export default function CircularIndeterminate() {
  return (
    <Box sx={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", minHeight: "50vh" }}>
      <CircularProgress />
    </Box>
  );
}
